class ZcyGXHeader {

}

module.exports = ZcyGXHeader;
